import { Component, Input } from '@angular/core';
import { LoginLoadComponent } from "../login-load/login-load.component";
import { TfaComponent } from "../tfa/tfa.component";
import { TfaType } from '@modules/settings/components/manage-users/interfaces/interfaces';
import { AuthService } from '@core/services/auth/auth.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tfa-page',
  standalone: true,
  imports: [LoginLoadComponent, TfaComponent],
  templateUrl: './tfa-page.component.html',
  styleUrl: './tfa-page.component.scss'
})
export class TfaPageComponent {
  isVerifying: boolean = false;

  constructor(
    protected _auth: AuthService,
    private _messageService: MessageService,
    private _router: Router
  ) { }

  ngOnInit() {
    if(Object.keys(this._auth.tfaConfig()).length === 0) {
      this._auth.getUserDetails().subscribe({
        next: (res: any) => {
          this._auth.userDetail.set(res);
          this._auth.signTFA(this._auth.userDetail()._id).subscribe(
            (tfaRes: any) => {
              this._auth.tfaConfig.set(tfaRes.tfa);
            },
            (err) => {
              this._messageService.add({
                key: 'tr',
                severity: 'warn',
                summary: 'Warning',
                detail: err.error.message || 'Something went wrong',
              });
            }
          );
        },
        error: (err) => {
          this._messageService.add({
            key: 'tr',
            severity: 'warn',
            summary: 'Warning',
            detail: err.error.message || 'Something went wrong',
          });
        },
      })
    }
  }

  verifyOTP(totp: string) {
    this.isVerifying = true;
    this._auth.verifyTFA(this._auth.userDetail()._id, totp).subscribe({
        next: (res: any) => {
          this._auth.userDetail.set({
            ...this._auth.userDetail(),
            isPasswordUpdatedByUser: res.isPasswordUpdatedByUser,
            isTfaConfigured: res.isTfaConfigured,
          });
          this.isVerifying = false;
          this._router.navigate(['/']);
        },
        error: (err) => {
          this.isVerifying = false;
          this._messageService.add({
            key: 'tr',
            severity: 'warn',
            summary: 'Warning',
            detail: err.error.message || 'Invalid OTP',
          });
        },
      });
  }

}
